
const prod = [
  {
    path: '/',
    name: 'homepage',
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/homepage.' + process.env.VUE_APP_PREFIX + '.vue').then(Homepage => {
      return Homepage
    }),
  },
  {
    path: '/c/:discount_code_url?/:name_url?/:surname_url?/:email_url?',
    name: 'homepage-c',
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/homepage.' + process.env.VUE_APP_PREFIX + '.vue').then(Homepage => {
      return Homepage
    }),
    props: route => ({
      discount_code_url: route.params.discount_code_url,
      name_url: route.params.name_url,
      surname_url: route.params.surname_url,
      email_url: route.params.email_url
    }),
  },
  {
    path: '/myautogrill/c/:discount_code_url?/:name_url?/:surname_url?/:email_url?',
    name: 'homepage-autogrill-c',
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/homepage.tb.autogrill.vue').then(Homepage => {
      return Homepage
    }),
    props: route => ({
      discount_code_url: route.params.discount_code_url,
      name_url: route.params.name_url,
      surname_url: route.params.surname_url,
      email_url: route.params.email_url
    }),
  },
  {
    path: '/doublecheck/:confirmcode/:itinerary_id',
    name: 'doublecheck',
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/doublecheck').then(function (Doublecheck) {
      return Doublecheck
    }),
    props: (route) => {
      return {
        confirmcode: route.params.confirmcode,
        itinerary_id: route.params.itinerary_id,
      }
    },
  },
  {
    path: '/termini-e-condizioni',
    name: 'terms',
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/static-pages/terms').then(function (Terms) {
      return Terms
    }),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/static-pages/about.vue').then(function (About) {
      return About
    }),
  },
]

export {
  prod
}
